import { render, staticRenderFns } from "./TargetObjectField.vue?vue&type=template&id=3a9434e7"
import script from "./TargetObjectField.vue?vue&type=script&lang=js"
export * from "./TargetObjectField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports